import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface IconFrameProps {
  children: ReactNode;
  className?: string;
}

export const IconFrame = (props: IconFrameProps) => (
  <div className={cn('flex shrink-0 items-center justify-center', props.className)}>
    {props.children}
  </div>
);
